/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createCube } from '../../factoriesAny.js';
export var cubeDependencies = {
  typedDependencies: typedDependencies,
  createCube: createCube
};